import { HttpClient } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(private http: HttpClient) {}

  currentProject: WritableSignal<IProject> = signal({} as IProject);
  projects: any = signal(null);

  getProjectsList(): Observable<object> {
    return this.http.get('/api/projects');
  }

  getMyProjects(): Observable<object> {
    return this.http.get('/api/projects/me');
  }

  setCurrentProject(body: any = {}): Observable<object> {
    return this.http.put('/api/users/update-user-project', body);
  }

  createNewProject(payload: any = {}): Observable<any> {
    return this.http.post('/api/projects', payload);
  }

  updateProject(payload: any = {}, params: any = {}): Observable<any> {
    return this.http.put('/api/projects/' + params._id, payload);
  }

  getArchivedProjects(): Observable<any> {
    return this.http.get('/api/projects/archive');
  }

  archiveProjectById(params: any = {}): Observable<any> {
    return this.http.put('/api/projects/archive/' + params._id, {});
  }

  unArchiveProjectById(params: any = {}): Observable<any> {
    return this, this.http.put('/api/projects/unarchive/' + params._id, {});
  }
}
export interface IProject {
  _id: string;
  name: string;
  themeSettings?: any;
  createdAt?: any;
  updatedAt?: any;
  searchProvider?: string;
  isEnableAWB?: boolean;
  isContractUpload?: boolean;
  isAllowDownload?: boolean;
  isSearchShowExtractions?: boolean;
  isShowExtraction?: boolean;
  defaultExtractionType?: string;
  users?: any[];
}
